import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgKhm = function SvgKhm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.69 8.667h30.647c.528 2.514.69 5.055.66 7.35a33.98 33.98 0 0 1-.687 7.316H.682c-.548-2.53-.709-5.063-.679-7.35-.03-2.257.158-4.786.687-7.316Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.338 8.667H.69c.055-.264.114-.528.177-.792 0 0 1.028-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646.06.252.118.505.17.758ZM.682 23.333H31.31a29.56 29.56 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a25.83 25.83 0 0 1-.184-.79Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.667 18v3.333h-4.334V18h4.334Zm.666 0h1.334l2 3.333h-3.334V18Zm-5.666 0v3.333h-4.333V18h4.333Zm-5 0v3.333H7.334l2-3.333h1.333ZM18 15.333h2v-.666c.445-1.334.89-2 1.334-2 .444 0 .888.666 1.333 2v3H9.333v-3c.445-1.334.89-2 1.334-2 .444 0 .889.666 1.333 2v.666h2v-.666c.667-2.667 1.334-4 2-4 .667 0 1.334 1.333 2 4v.666Z",
    fill: "#fff"
  }));
};

export default SvgKhm;